import styled, { css } from 'styled-components';
import { SYS_SPACE_RELATIVE_MD, SYS_SPACE_RELATIVE_4_XL } from '@oneaudi/unified-web-common';
import type {
  AdditionalDealerDataContentProps,
  AdditionalDealerDataProps,
} from '../../interfaces/header-styled-components.interfaces';
import { customEaseOut } from '../../utils/globals';
import { Headline, Text } from '@oneaudi/unified-web-components';

export const AdditionalDealerData = styled.div<AdditionalDealerDataProps>`
  ${({ isMobileView }) => !isMobileView && 'display: none;'};
  @media (min-width: 1440px) {
    display: block;
  }
  transition:
    max-height 350ms ${customEaseOut},
    visibility 350ms ${customEaseOut};
  color: var(--one-header-color-black);
  ${({ theme, isMobileView, isDealerSearch }) =>
    theme.type === 'legacy'
      ? isMobileView
        ? 'background: var(--one-header-color-grey-light);'
        : 'background: var(--one-header-color-white);'
      : isDealerSearch
        ? 'background: var(--one-header-color-default);'
        : `background: linear-gradient(180deg, ${theme.colors.colorElevationLevel2Stops0} 0%, ${theme.colors.colorElevationLevel2Stops1} 100%);`};
  top: ${({ isMobileView }) => (isMobileView ? 0 : 'var(--one-header-height)')};
  position: ${({ isMobileView }) => (isMobileView ? 'relative' : 'absolute')};
  ${({ open }) => !open && 'overflow-y: scroll;'};
  max-height: ${({ open }) => (open ? '100vh' : 0)};
  scrollbar-width: none; /*  hide scrollbar for Firefox */

  ${({ isMobileView }) =>
    !isMobileView &&
    css`
      height: calc(var(--viewport-height) - var(--one-header-height));
    `}
  ${({ open, isMobileView, theme }) =>
    open &&
    isMobileView &&
    css`
      border-bottom: 1px solid var(${theme.colors.colorBaseGrey20});
    `}
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
`;

export const AdditionalDealerDataContent = styled.div<AdditionalDealerDataContentProps>`
  ${({ isDealerSearch, isMobileView }) =>
    !isDealerSearch &&
    `padding: calc(var(--one-header-space-xxl) - var(--one-header-space-l) / 2); ${isMobileView ? '--one-header-side-spacing' : 'var(--one-header-space-xl);'} ${SYS_SPACE_RELATIVE_4_XL}`};
  display: flex;
  flex-direction: column;

  & .services {
    display: flex;
    flex-direction: column;
    & .modified-services {
      font-size: ${({ theme }): string => theme.typography.fontSizeL};
      margin: 0 0 ${({ theme }): string => theme.spacing.s} 0;
      font-stretch: 130%;
    }
  }

  & .back-to-dealer {
    margin: ${({ theme }): string =>
      theme.type !== 'legacy'
        ? `${theme.spacing.l} 0 ${theme.spacing.xl} 0`
        : `${theme.spacing.l} 0 ${theme.spacing.l} 0`};
    ${({ theme }): string =>
      theme.type !== 'legacy' ? `font-size: ${theme.typography.fontSizeS}` : ''};
    ${({ theme }): string => (theme.type !== 'legacy' ? 'min-height: 36px' : '')};
    ${({ theme }): string => (theme.type !== 'legacy' ? `padding: ${theme.spacing.xs} 0` : '')};
  }
`;

export const AdditionalDealerDataActionsBottom = styled.div<AdditionalDealerDataContentProps>`
  display: flex;
  ${({ theme }): string =>
    theme.type === 'legacy'
      ? `border-top: 1px solid ${theme.colors.colorBaseGrey5};`
      : `border-top: 2px solid ${theme.colors.divider};`}
  ${({ theme }): string =>
    theme.type === 'legacy'
      ? `padding: var(--one-header-space-l) 0 calc(var(--one-header-space-l) + 5px);`
      : `padding: ${theme.spacing.l} 0 ${theme.spacing.l}`};
  margin-top: ${({ theme }): string => theme.spacing.m};

  button {
    ${({ theme }): string => (theme.type === 'alpha' ? 'padding-left: 0;' : '')};
  }

  div {
    margin-right: ${({ theme }): string => theme.spacing.m};
  }
`;

export const AdditionalDealerDataDisconnectButton = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
  display: flex;
  flex-wrap: nowrap;
  padding: 0;
  margin-right: ${SYS_SPACE_RELATIVE_MD}px;
  & svg {
    color: ${({ theme }): string => (theme.type === 'legacy' ? '' : theme.colors.icon)};
  }
  &:focus-visible {
    ${({ theme }): string =>
      theme.type === 'legacy'
        ? `outline: 2px solid;`
        : `outline: 2px solid ${theme.colors.colorBaseWhite};`}
    border-radius: 3px;
  }
`;

export const AdditionalDealerDataInfoButton = styled.div`
  position: relative;
  background: transparent;
  align-items: flex-start;
  margin-left: var(--one-header-space-m);
`;

export const StyledHeadline = styled(Headline)`
  -webkit-font-smoothing: antialiased;
`;

export const StyledText = styled(Text)`
  -webkit-font-smoothing: antialiased;
`;
